import { useRef } from 'react';
import { Whisper, Button } from 'rsuite';
import { TableCell } from '@mui/material';
import { icons } from '@shared/static/icons';
import { CardMenu } from '@widgets/cards/menu';

export default function CardActionCell({ row }) {
  const ref = useRef();

  function close() {
    ref.current.close();
  }

  return (
    <TableCell data-skip-row-click>
      <Whisper
        placement="auto"
        controlId="control-id-with-dropdown"
        trigger="click"
        ref={ref}
        speaker={<CardMenu data={row} close={close} />}
      >
        <Button appearance="secondary" className="rs-btn-icon">
          {icons.more}
        </Button>
      </Whisper>
    </TableCell>
  );
}
